import { graphql } from '@api/generated/gql';

const cancelWrapupMutation = graphql(`
  mutation cancelUserWrapupActivity($userId: ID!) {
    cancelUserWrapupActivity(userId: $userId) {
      userId
      availabilityActivityStatus {
        activityStatus
        availabilityStatus
      }
      stats {
        lastActionAt
        lastHandledAt
        lastIdleAt
        loginAt
        totalSessions
        offeredSessions
        missedSessions
        avgCallTime
      }
    }
  }
`);

export default cancelWrapupMutation;
